import { render } from "./YAxisForm.vue?vue&type=template&id=7d5beff4"
import script from "./YAxisForm.vue?vue&type=script&lang=js"
export * from "./YAxisForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__